export default __webpack_public_path__ + "static/media/availableOffers.b2360dd5.svg";